export default __webpack_public_path__ + "13cf6a8ebe19852573a03c64dda64420.svg";